<div *ngIf="listData !== null">
  <app-kontable
          title="{{ 'common.stores_title' | translate }}"
          [columns]="['id', 'code', 'host_code', 'name', 'short_name', 'city', 'description', 'region', 'salesNetworkName']"
          [titles]="['ID', 'common.storeCode', 'common.storeHostCode', 'common.storeName', 'common.storeShortName', 'common.city', 'common.description', 'common.storeRegion','division_sales_network.sales_network_id']"
          [service]="svc"
          [paginationType]="pagination"
          [showGlobalFilter]="false"
          [showDetailsButton]="false"
          [showRecoverButton]="false"
          [showInfoButton]="false"
          [showAddButton]="true"
          [showDeleteButton]="deleteStorePermission"
          (onAdd)="addStore($event)"
          (onEdit)="editStore($event)"
          (onRemove)="delete($event)"
          [(fireNewDataAvailable)]="newDataAvailable"
  >
  </app-kontable>
</div>





// WEBPACK FOOTER //
// ./src/app/views/administration/store/store-common-component.html